import { Maybe } from 'maybeasy';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { currentUserStore } from '../../../../../../CurrentUserStore';
import { findLink } from '../../../../../../LinkyLinky';
import { T } from '../../../../../../Translations';
import { cloneLearningCollection } from '../../Clone/CloneLearningCollection';
import CloneStore from '../../Clone/Store';

export interface Props {
  id: number;
  name: string;
  cloneStore: CloneStore;
}

// Clone reads the source via edit-learning-collection-template-v2 (which
// requires Builder v2 access) and writes via create-learning-collection-
// template-v2, so both links must be present for the flow to succeed.
// Gating on create alone let Builder v1 users (who get create via the EXO
// chatbot path) see a Clone action that failed before any request fired.
export const cloneLink = ({ id, name, cloneStore }: Props): Maybe<React.ReactNode> =>
  findLink('edit-learning-collection-template-v2', currentUserStore.links)
    .andThen(() => findLink('create-learning-collection-template-v2', currentUserStore.links))
    .map(() => (
      <Link
        key="clone-learning-collection"
        to={'#'}
        onClick={() => cloneLearningCollection(id, name, cloneStore)}
        className="px-4 py-2.5"
        data-intercom-target="clone-collection-action"
      >
        <T kind="Clone" />
      </Link>
    ));
